import { Dropdown, Flex, Input } from '@components';
import { styled } from '@mui/material';

export const ContentContainer = styled(Flex)(({ theme }) => ({
  flex: 1,
  flexDirection: 'column',
  padding: theme.spacing(5, 17),
  paddingTop: theme.spacing(0),
  maxWidth: '75%',
  [theme.breakpoints.between('md', 'lg')]: {
    maxWidth: '90%',
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(16, 10),
    maxWidth: '100%',
  },
}));

export const StyledInput = styled(Input)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

export const StyledDropdown = styled(Dropdown)(({ theme }) => ({
  marginTop: theme.spacing(10),
  overflow: 'hidden',
  paddingLeft: theme.spacing(6),
  paddingRight: theme.spacing(6),
  paddingTop: 0,
  paddingBottom: 0,
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));

export const InputContainer = styled(Flex)(({ theme }) => ({
  marginTop: theme.spacing(10),
  gap: theme.spacing(10),
  flexWrap: 'nowrap',
  [theme.breakpoints.down('md')]: {
    flexWrap: 'wrap',
  },
}));
